import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = { class: "logs-controls" }
const _hoisted_3 = { class: "logs-type-btns" }
const _hoisted_4 = { class: "logs-page-size" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "logs-empty"
}
const _hoisted_8 = {
  key: 1,
  class: "logs-empty muted"
}
const _hoisted_9 = { class: "log-scroll" }
const _hoisted_10 = { class: "admin-table" }
const _hoisted_11 = { class: "td-nowrap" }
const _hoisted_12 = { class: "log-val" }
const _hoisted_13 = { class: "log-val" }
const _hoisted_14 = { class: "logs-footer" }
const _hoisted_15 = { class: "logs-count" }
const _hoisted_16 = {
  key: 0,
  class: "paginator"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "logs-empty"
}
const _hoisted_23 = {
  key: 1,
  class: "logs-empty muted"
}
const _hoisted_24 = { class: "log-scroll" }
const _hoisted_25 = { class: "admin-table" }
const _hoisted_26 = { class: "td-nowrap" }
const _hoisted_27 = { class: "logs-footer" }
const _hoisted_28 = { class: "logs-count" }
const _hoisted_29 = {
  key: 0,
  class: "paginator"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["log-type-btn", { 'log-type-btn--active': $setup.activeLog === 'actions' }]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.activeLog = 'actions'))
        }, "Log de Ações", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["log-type-btn", { 'log-type-btn--active': $setup.activeLog === 'login' }]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.activeLog = 'login'))
        }, "Login Logs", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "logs-per-page",
          class: "logs-per-page-label"
        }, "Por página:", -1)),
        _createElementVNode("select", {
          id: "logs-per-page",
          class: "logs-per-page-select",
          value: $setup.pageSize,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onPageSizeChange && $setup.onPageSizeChange(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pageSizeOptions, (n) => {
            return (_openBlock(), _createElementBlock("option", {
              key: n,
              value: n
            }, _toDisplayString(n), 9, _hoisted_6))
          }), 128))
        ], 40, _hoisted_5)
      ])
    ]),
    ($setup.activeLog === 'actions')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($setup.logsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Carregando..."))
            : ($setup.logs.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Nenhum log registrado."))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("table", _hoisted_10, [
                      _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Data/Hora"),
                          _createElementVNode("th", null, "Admin"),
                          _createElementVNode("th", null, "Ação"),
                          _createElementVNode("th", null, "Campo"),
                          _createElementVNode("th", null, "Antes"),
                          _createElementVNode("th", null, "Depois")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pagedLogs, (log) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: log.id
                          }, [
                            _createElementVNode("td", _hoisted_11, _toDisplayString($setup.formatDateTime(log.createdAt)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(log.masterAdminUsername), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(log.action), 1),
                            _createElementVNode("td", null, _toDisplayString(log.fieldChanged || '—'), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString(log.valueBefore || '—'), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(log.valueAfter || '—'), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString($setup.logs.length) + " registro" + _toDisplayString($setup.logs.length !== 1 ? 's' : ''), 1),
                    ($setup.totalLogPages > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.logsPage === 1,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.logsPage = 1)),
                            type: "button"
                          }, "«", 8, _hoisted_17),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.logsPage === 1,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.logsPage--)),
                            type: "button"
                          }, "‹", 8, _hoisted_18),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.logPageNumbers, (p, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: i,
                              class: _normalizeClass(["pag-btn", { 'pag-btn--active': p === $setup.logsPage, 'pag-ellipsis': p === '…' }]),
                              disabled: p === '…',
                              type: "button",
                              onClick: ($event: any) => (p !== '…' && ($setup.logsPage = Number(p)))
                            }, _toDisplayString(p), 11, _hoisted_19))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.logsPage === $setup.totalLogPages,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.logsPage++)),
                            type: "button"
                          }, "›", 8, _hoisted_20),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.logsPage === $setup.totalLogPages,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.logsPage = $setup.totalLogPages)),
                            type: "button"
                          }, "»", 8, _hoisted_21)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
        ], 64))
      : _createCommentVNode("", true),
    ($setup.activeLog === 'login')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($setup.loginLogsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Carregando..."))
            : ($setup.loginLogs.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Nenhum login registrado."))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Data/Hora"),
                          _createElementVNode("th", null, "Usuário"),
                          _createElementVNode("th", null, "IP"),
                          _createElementVNode("th", null, "Status")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pagedLoginLogs, (ll) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: ll.id
                          }, [
                            _createElementVNode("td", _hoisted_26, _toDisplayString($setup.formatDateTime(ll.createdAt)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(ll.username), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(ll.ip || '—'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(ll.success ? 'badge-ok' : 'badge-fail')
                              }, _toDisplayString(ll.success ? 'Sucesso' : 'Falha'), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString($setup.loginLogs.length) + " registro" + _toDisplayString($setup.loginLogs.length !== 1 ? 's' : ''), 1),
                    ($setup.totalLoginPages > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.loginPage === 1,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.loginPage = 1)),
                            type: "button"
                          }, "«", 8, _hoisted_30),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.loginPage === 1,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.loginPage--)),
                            type: "button"
                          }, "‹", 8, _hoisted_31),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loginPageNumbers, (p, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: i,
                              class: _normalizeClass(["pag-btn", { 'pag-btn--active': p === $setup.loginPage, 'pag-ellipsis': p === '…' }]),
                              disabled: p === '…',
                              type: "button",
                              onClick: ($event: any) => (p !== '…' && ($setup.loginPage = Number(p)))
                            }, _toDisplayString(p), 11, _hoisted_32))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.loginPage === $setup.totalLoginPages,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.loginPage++)),
                            type: "button"
                          }, "›", 8, _hoisted_33),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: $setup.loginPage === $setup.totalLoginPages,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.loginPage = $setup.totalLoginPages)),
                            type: "button"
                          }, "»", 8, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}